import { LoadingButton } from "@mui/lab";
import usePermission from "hooks/usePermission";

const PermissionLoadingButton = ({
    permission,
    children,
    ...props
}) => {
    const { hasPermission } = usePermission();

    if (!hasPermission(permission)) {
        return null;
    }

    return (
        <LoadingButton {...props}>
            {children}
        </LoadingButton>
    );
};

export default PermissionLoadingButton;